import React from 'react';
import parseTextFromJson from "../utils/parseOldArticle";
import SmiWidget from "../template2013/SmiWidget"
import {AfterContent} from "./adblocks/AfterContent"

function calculateChunksCount(chunksLength) {
    const configArray = [
        {chunkLength: 3, config: {adfoxNum: 1, paragraphNum: 1}},
        {chunkLength: 6, config: {adfoxNum: 1, paragraphNum: 2}},
        {chunkLength: 8, config: {adfoxNum: 2, paragraphNum: 3}},
        {chunkLength: 12, config: {adfoxNum: 2, paragraphNum: 4}},
        {chunkLength: 16, config: {adfoxNum: 3, paragraphNum: 4}},
        {chunkLength: 20, config: {adfoxNum: 4, paragraphNum: 4}},
    ];
    if (chunksLength >= 20) {
        return {adfoxNum: 4, paragraphNum: 5};
    }
    if (chunksLength < 3) {
        return {adfoxNum: 0, paragraphNum: 0};
    }
    for (const item of configArray) {
        if (chunksLength < item.chunkLength) {
            return item.config;
        }
    }
}

function split(news) {
    let el = document.createElement("div");
    if (news.content[0] === '{') {
        el.innerHTML = parseTextFromJson(news.content);
    } else {
        el.innerHTML = news.content;
    }
    const chunks = Array.from(el.children).map(el => el.innerHTML);
    const config = calculateChunksCount(chunks.length);
    for (let i = 1; i < config.adfoxNum + 1; i++) {
        chunks.splice(config.paragraphNum * i, 0, "ADFOX");
    }
    return chunks;
}

function getAdfoxComponents(isDesktop) {
    const adfoxComponentsPc = {
        1: <SmiWidget blockId={'30219'}/>,
        2: <SmiWidget blockId={'30218'}/>,
        3: <SmiWidget blockId={'30220'}/>,
        4: <SmiWidget blockId={'30221'}/>,
    };
    const adfoxComponentsMob = {
        1: <SmiWidget blockId={'30225'}/>,
        2: <SmiWidget blockId={'30226'}/>,
        3: <SmiWidget blockId={'30227'}/>,
        4: <SmiWidget blockId={'30228'}/>,
    };
    return isDesktop ? adfoxComponentsPc : adfoxComponentsMob
}

function NewsText({news, isDesktop}) {

    const contentRef = React.useRef(null);
    const url = new URL(window.location.href);
    const full = url.searchParams.get("full");
    const isFull = !!full;
    const chunks = split(news);
    const adfoxNum = calculateChunksCount(chunks.length)["adfoxNum"];
    const selectedComponentsMap = getAdfoxComponents(isDesktop);
    let cnt = 1;
    const publishDate = news.publish_date.toString().split(' ')[0] + ' ' + news.publish_date.toString().split(' ')[1];
    const fullNewsUrl = new URL(url);
    if (fullNewsUrl.pathname.includes("preview/")) {
        fullNewsUrl.pathname = fullNewsUrl.pathname.replace(/\/(preview|news|preview\/news)\//, "full/");
    } else {
        fullNewsUrl.searchParams.set('full', '1');
    }

    return (
        <div className="newsDetail">
            <div className="main-news-wrap">
                <div className="content">
                    <div className="publish-date">{publishDate}</div>
                    <div className="news-title-200">{news.title}</div>
                </div>
                <div className="image">
                    <img src={news.image} alt={news.title}/>
                </div>
            </div>
            <div className="text-news" ref={contentRef}>
                {chunks.map((chunk, i) => {
                    if (chunk === "ADFOX" && cnt <= adfoxNum && isFull) {
                        cnt += 1;
                        return <React.Fragment
                            key={cnt - 1}>{selectedComponentsMap[cnt - 1]}</React.Fragment>;
                    }
                    if (i === chunks.length - 1) {
                        cnt = 1;
                    }
                    return (
                        <React.Fragment key={i}>
                            <p hidden={!isFull && chunk === "ADFOX"} dangerouslySetInnerHTML={{__html: chunk}}/>
                        </React.Fragment>
                    );
                })}
            </div>
            <AfterContent isDesktop={isDesktop}/>
        </div>
    );
}

NewsText.defaultProps = {
    teasers: [],
};

export default NewsText;
